export const GET_HISTORY = 'GET_HISTORY';
export const SET_HISTORY = 'SET_HISTORY';
export const ERROR_HISTORY = 'ERROR_HISTORY';